<script setup lang="ts">
import { PictureFields, PicturePreset } from './Picture.vue'
import { VideoFields } from './Video.vue'
import { IconFields } from './Icon.vue'
import { WidthVariants } from '~/types/Content'

type SupportingData = {
  home: {
    width?: { value: WidthVariants }
  }
}

export type MediaProps = {
  fields?: (PictureFields | VideoFields | IconFields) & { supportingData?: SupportingData }
  sys?: {
    contentType: {
      sys: { id: 'video' | 'picture' | 'icon' }
    }
  }
  preset?: PicturePreset
  loading?: 'lazy' | 'eager' | undefined
  fetchpriority?: 'high' | 'low' | 'auto' | undefined
}

const props = defineProps<MediaProps>()
const type = props.sys?.contentType?.sys?.id || 'picture'
const widthClass = props?.fields?.supportingData?.home?.width?.value === 'wide' ? 'media--wide' : 'media--narrow'
</script>

<template>
  <!-- @vue-skip -->
  <Picture
    v-if="type === 'picture'"
    class="media--picture"
    :class="widthClass"
    v-bind="{ fields }"
    :loading="loading"
    :preset="preset"
    :fetchpriority="fetchpriority"
  />
  <Icon v-else-if="type === 'icon'" class="media--icon" v-bind="{ fields }" :loading="loading" />
  <Video v-else-if="type === 'video'" class="media--video" :class="widthClass" v-bind="{ fields }" />
  <div v-else>Unknown Media Type</div>
</template>
